import DemoSection from '../DemoSection';
import { UIButton } from '../WebComponents';

export default function ButtonDemo() {
  return (
    <DemoSection title="Button 按钮" description="按钮用于触发一个操作">
      <DemoSection.Item title="基础用法">
        <div className="demo-content">
          <UIButton variant="primary">主要按钮</UIButton>
          <UIButton variant="secondary">次要按钮</UIButton>
          <UIButton variant="outline">轮廓按钮</UIButton>
          <UIButton variant="ghost">幽灵按钮</UIButton>
        </div>
        <div className="code-block">
          <code>{`<UIButton variant="primary">主要按钮</UIButton>
<UIButton variant="secondary">次要按钮</UIButton>
<UIButton variant="outline">轮廓按钮</UIButton>
<UIButton variant="ghost">幽灵按钮</UIButton>`}</code>
        </div>
      </DemoSection.Item>

      <DemoSection.Item title="尺寸">
        <div className="demo-content">
          <UIButton variant="primary" size="small">小按钮</UIButton>
          <UIButton variant="primary" size="medium">中等按钮</UIButton>
          <UIButton variant="primary" size="large">大按钮</UIButton>
        </div>
        <div className="code-block">
          <code>{`<UIButton variant="primary" size="small">小按钮</UIButton>
<UIButton variant="primary" size="medium">中等按钮</UIButton>
<UIButton variant="primary" size="large">大按钮</UIButton>`}</code>
        </div>
      </DemoSection.Item>

      <DemoSection.Item title="禁用状态">
        <div className="demo-content">
          <UIButton variant="primary" disabled>禁用按钮</UIButton>
        </div>
        <div className="code-block">
          <code>{`<UIButton variant="primary" disabled>禁用按钮</UIButton>`}</code>
        </div>
      </DemoSection.Item>
    </DemoSection>
  );
}
